import React, { Component } from 'react'
import {
	Breadcrumb,
	BreadcrumbItem,
	Card,
	CardBody,
	CardFooter,
	Container
} from 'reactstrap';

class AdminSettingsRoute extends Component {
	render() {
		return (
			<div>
				<Breadcrumb tag="ol">
					<BreadcrumbItem tag="li">
						<a>Ecofresh Admin CP</a>
					</BreadcrumbItem>
					<BreadcrumbItem active tag="li">Settings</BreadcrumbItem>
				</Breadcrumb>
			</div>
		);
	}
}

export default AdminSettingsRoute


// WEBPACK FOOTER //
// ./src/admin-components/routes/AdminSettingsRoute.js